export class Config {
  private static configData: any;
  public static GetConfigData = () => {
    var json: string = '';
    if (!Config.configData) {
      var env = Config.getEnvironment();
      json = Config.loadTextFileAjaxSync(`Config/config.${env}.json`, "application/json");
      let data = JSON.parse(json);
      Config.configData = data;
    }
    return Config.configData;
  }

  private static loadTextFileAjaxSync = (filePath: string, mimeType: string): string => {
    let xmlhttp = new XMLHttpRequest();
    xmlhttp.open("GET", filePath, false);
    if (mimeType != null) {
      if (xmlhttp.overrideMimeType) {
        xmlhttp.overrideMimeType(mimeType);
      }
    }
    xmlhttp.send();
    if (xmlhttp.status === 200 && xmlhttp.readyState === 4) {
      return xmlhttp.responseText;
    }
    else {
      throw new Error('Error in loading data');
    }
  }

  public static getEnvironment = () => {
    var envJson = Config.loadTextFileAjaxSync(`Config/environment.config.json`, "application/json");
    var env = JSON.parse(envJson).environment;
    return env;
  }
}
